import * as React from 'react';
export const IcNoRepair = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M4.785 3.29a1.004 1.004 0 10-1.42 1.42l5.88 5.88-5.29 5.29a3 3 0 104.24 4.24l5.29-5.29 5.88 5.88a.998.998 0 001.42 0 .997.997 0 00.219-1.095.998.998 0 00-.22-.325l-16-16zm17 0l-1-1a1 1 0 00-1.16-.18l-2 1a1 1 0 00-.5.57l-.92 2.78-2.72 2.71 1.42 1.42 2.71-2.72 2.78-.87a1 1 0 00.57-.5l1-2a1 1 0 00-.18-1.21z'
      fill='currentColor'
    />
  </svg>
);
